import merge from 'lodash/merge';
import {
  enUS as enUSAdapter,
  he as heILAdapter
} from 'date-fns/locale';
// core
import {
  enUS as enUSCore,
  heIL as heILCore
} from '@mui/material/locale';
// date-pickers
import {
  enUS as enUSDate,
  heIL as heILDate
} from '@mui/x-date-pickers/locales';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSCore),
    adapterLocale: enUSAdapter,
  },
  {
    label: 'Hebrew',
    value: 'he',
    systemValue: merge(heILDate, heILCore),
    adapterLocale: heILAdapter,
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
